import React from "react";
import { Button } from "@telia/teddy";
import { connect } from "react-redux";
import { FORM_ID } from "../../../../../../constants";
import { RootState } from "../../../../../../models";
import * as AUTH_AT from "../../../../authentication/state/actionTypes";
import { selectors as LOADING_SELECTORS } from "../../../../loading";

interface StateProps {
    isSubmittingDsfMismatchForm: boolean;
}

interface Props extends StateProps {
    isSubmitting?: boolean;
}

const DsfMismatchFormContinueButton: React.FC<Props> = ({ isSubmittingDsfMismatchForm, isSubmitting = false }) => {
    return (
        <Button
            id="personal-details-form-button"
            form={FORM_ID.DSF_MISMATCH}
            loading={isSubmittingDsfMismatchForm || isSubmitting}
            type="submit"
        >
            Gjør et nytt søk
        </Button>
    );
};

const mapStateToProps = (state: RootState) => ({
    isSubmittingDsfMismatchForm: LOADING_SELECTORS.isTypeLoading(state, AUTH_AT.AUTH_BANK_ID_GRANT),
});

export default connect(mapStateToProps)(DsfMismatchFormContinueButton);
